import { enterTransition, exitTransition } from "@/lib/motion";

export const panelClass =
  "z-[80] overflow-hidden rounded-panel border border-line-subtle bg-surface-raised p-2 text-sm text-foreground shadow-floating outline-none";

export const itemClass =
  "flex min-h-11 w-full cursor-pointer items-center justify-between gap-3 rounded-control px-3 py-2 text-left text-sm text-foreground outline-none select-none data-[disabled]:pointer-events-none data-[disabled]:text-muted data-[highlighted]:bg-surface-muted";

export function panelMotion(reduce: boolean | null) {
  return {
    transition: enterTransition(reduce),
    exitTransition: exitTransition(reduce),
  };
}
